import React from "react";
import Main from "../main";
export default function CommonQuestions() {
  return (
    <Main>
      <div>
        <div>
          <p className="font-bold">1. Ask for nationality</p>
        </div>
        <div>
          <p className="font-bold">Chủ ngữ </p>là người nước nào
        </div>
        <div>Subject + to be + what your nationality</div>
        <div>Anh là người nước nào?</div>
      </div>
      <div>
        <div>
          <p className="font-bold">2. Where are you from?</p>
        </div>
        <div>
          <p className="font-bold">Chủ ngữ </p>đến từ đâu
        </div>
        <div>Subject + come from + country</div>
        <div>Anh đến từ đâu?</div>
      </div>
      <div>
        <div>
          <p className="font-bold">3. Ask about health</p>
        </div>
        <div>
          <p className="font-bold">Chủ ngữ </p>có khỏe không
        </div>
        <div>Subject + how are you</div>
        <div>Hôm nay em có khỏe không?</div>
      </div>
      <div>
        <div>
          <p className="font-bold">4. What is your job</p>
        </div>
        <div>
          <p className="font-bold">Chủ ngữ </p>làm ngề gì
        </div>
        <div>Subject + what is your job</div>
        <div>Anh làm ngề gì?</div>
      </div>
      <div>
        <div>
          <p className="font-bold">5. Ask for age</p>
        </div>
        <div>
          <p className="font-bold">Chủ ngữ </p>bao nhiêu tuổi
        </div>
        <div>Subject + how old</div>
        <div>Anh bao nhiêu tuổi?</div>
      </div>
      <div>
        <div>
          <p className="font-bold">6. Asking price</p>
        </div>
        <div>
          <p className="font-bold">Chủ ngữ </p>bao nhiêu tiền a
        </div>
        <div>Subject + how much</div>
        <div>Anh bao nhiêu tiền a?</div>
      </div>
      <div>
        <div>
          <p className="font-bold">7. Asking time</p>
        </div>
        <div>Mấy giờ rồi?</div>
      </div>
      <div>
        <div>
          <p className="font-bold">8. Ask about where you are living</p>
        </div>
        <div>
          <p className="font-bold">Chủ ngữ </p>đang sống ở đâu
        </div>
        <div>Subject + where are living</div>
        <div>Anh đang sống ở đâu?</div>
      </div>
    </Main>
  );
}
